import React from 'react';
import Input from '../input';
import DropdownComp from '../dropdown';

const DynamicAddProductRow = (props) => {
    // eslint-disable-next-line
    const { index, values, handleChange, handleRemoveProduct, setFieldValue, isSubmitting, brands, products, quantity, getProductsList, touched, errors } = props
    return (
        <div className="form-row">

            <div className="form-group col-md-4">

                <DropdownComp
                    id={`productAccess[${index}].productName`}
                    name={`productAccess[${index}].productName`}
                    onChange={(selectedValue) => {
                        setFieldValue(`productAccess[${index}].productName`, selectedValue)
                    }}
                    value={values.productAccess[index].productName}
                    options={products}
                    label="Product Name"
                    placeholder="Please Select"
                    error={touched.productAccess && errors.productAccess && errors.productAccess[index] && errors.productAccess[index].productName}
                    errorText={errors.productAccess && errors.productAccess[index] && errors.productAccess[index].productName}
                    disabled={isSubmitting} />
            </div>
            <div className="form-group col-md-4">
                <Input
                    id={`productAccess[${index}].quantity`}
                    name={`productAccess[${index}].quantity`}
                    placeholder="Quantity"
                    type="text"
                    label="Quantity"
                    value={values.quantity}
                    onChange={handleChange}
                    error={touched.productAccess && errors.productAccess && errors.productAccess[index] && errors.productAccess[index].quantity}
                    errorText={errors.productAccess && errors.productAccess[index] && errors.productAccess[index].quantity}
                    disabled={isSubmitting} />

                {values.productAccess && values.productAccess.length > 1 &&
                    <button type="button" class="close" aria-label="Close"
                        id={`productAccess[${index}].deleteProduct`}
                        name={`productAccess[${index}].deleteProduct`}
                        style={{
                            marginRight
                                : '-100px', padding: '-4px',


                            top: '30px',
                            width: '30px'
                        }}
                        onClick={handleRemoveProduct}
                    >
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.146-3.146a.5.5 0 0 0-.708-.708L8 7.293 4.854 4.146a.5.5 0 1 0-.708.708L7.293 8l-3.147 3.146a.5.5 0 0 0 .708.708L8 8.707l3.146 3.147a.5.5 0 0 0 .708-.708L8.707 8l3.147-3.146z" />
                        </svg>
                    </button>}
              
            </div>


        </div >
    )
}
export default DynamicAddProductRow;